import { gql } from "../../../../../gql/__generated__/gql";

export const GET_USER_BALANCE = gql(`
  query getUserBalance {
    getUserBalance
  }
`);
